import styled from 'styled-components';
import { Grid } from '@material-ui/core';

const List = styled(Grid)`
	&.MuiGrid-container {
		width: 100%;
		margin: 5% 0px;
	}
`;

export default List;
